/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const TranslationsSvg = () => (
  <svg
    width="1.1em"
    height="1.1em"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.01786 1.66239H8.83929V3.85882H9.85714V1.0731C9.85714 0.836049 9.66563 0.644531 9.42857 0.644531H0.428571C0.191518 0.644531 0 0.836049 0 1.0731V10.9302C0 11.1673 0.191518 11.3588 0.428571 11.3588H7.71429V10.341H1.01786V1.66239Z" fill="#currentColor"/>
    <path d="M4.69154 2.56659H3.87993C3.8344 2.56659 3.79422 2.59606 3.77815 2.63891L2.07591 7.56749C2.0719 7.5782 2.07056 7.59025 2.07056 7.60231C2.07056 7.66123 2.11877 7.70945 2.1777 7.70945H2.91565C2.96118 7.70945 3.00136 7.67999 3.01743 7.63713L3.45538 6.37016H6.08306L4.79466 2.63891C4.78662 2.61797 4.77251 2.5999 4.75414 2.58701C4.73577 2.57413 4.71397 2.56702 4.69154 2.56659ZM4.85761 5.62016H3.71252L4.28574 3.96213L4.85761 5.62016ZM11.6786 6.20945H9.85716V4.96391C9.85716 4.90499 9.80895 4.85677 9.75002 4.85677H9.00002C8.94109 4.85677 8.89288 4.90499 8.89288 4.96391V6.20945H7.07145C6.89332 6.20945 6.75002 6.35275 6.75002 6.53088V8.88802C6.75002 9.06615 6.89332 9.20945 7.07145 9.20945H8.89288V11.2452C8.89288 11.3041 8.94109 11.3523 9.00002 11.3523H9.75002C9.80895 11.3523 9.85716 11.3041 9.85716 11.2452V9.20945H11.6786C11.8567 9.20945 12 9.06615 12 8.88802V6.53088C12 6.35275 11.8567 6.20945 11.6786 6.20945ZM8.89288 8.24516H7.71431V7.17374H8.89288V8.24516ZM11.0357 8.24516H9.85716V7.17374H11.0357V8.24516Z" fill="#currentColor"/>
  </svg>

);

export const TranslationsIcon = props => <Icon component={TranslationsSvg} {...props} />;
